/*
  Clipz-it, lot D (21/10/2026). Fiche produit sur Horizon, code Clipz-it.
  Horizon met à jour ses propres blocs (prix, galerie, bouton) au changement de variante, à partir du
  HTML de la section qu'il vient de recevoir. Nos blocs en Liquid personnalisé ne sont pas concernés :
  tout élément marqué data-cz-maj="<nom>" est remplacé par son homologue du HTML reçu
  (pastille de remise, etc.).
*/
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
  event.promise
    ?.then(({ detail }) => {
      const html = detail && detail.html;
      if (!html || typeof html.querySelector !== 'function') return;
      document.querySelectorAll('[data-cz-maj]').forEach((el) => {
        const nom = el.getAttribute('data-cz-maj');
        const neuf = html.querySelector(`[data-cz-maj="${nom}"]`);
        if (neuf) el.replaceWith(neuf.cloneNode(true));
      });
    })
    .catch(() => {});
});

/* ------------------------------------------------------------------------------------------------
  Lot D bis (21/10/2026), ajouts.
------------------------------------------------------------------------------------------------ */

/*
  1. Clic sur une pastille : la photo du coloris devient la GRANDE photo, en tête de galerie
  (comportement du LIVE et du correctif « galerie ordre fixe » du 15/10). À l'arrivée sur la fiche
  (?variant= depuis Google Shopping), le Liquid garde l'ordre des médias et démarre sur la photo du
  coloris : c'est la décision de Thibaut du 15/10, inchangée. Au changement de variante, Horizon remplace
  la galerie par celle du HTML reçu ; on écoute en phase de capture pour retoucher ce HTML AVANT qu'il ne
  soit inséré : la diapositive de départ (initial-slide) passe en tête, avec sa vignette, sa vignette du
  zoom et son média du zoom, et les index sont renumérotés.
*/
function czPermuter(items, k, renum) {
  if (!items.length || k <= 0 || k >= items.length) return;
  items[0].before(items[k]);
  const ordre = [items[k], ...items.slice(0, k), ...items.slice(k + 1)];
  ordre.forEach((el, i) => renum(el, i));
}
function czAttr(el, nom, motif, valeur) {
  const a = el.getAttribute(nom);
  if (a != null) el.setAttribute(nom, a.replace(motif, valeur));
}
function czGalerieCouleurEnTete(galerie) {
  const diaporama = galerie && galerie.querySelector('slideshow-component[initial-slide]');
  if (!diaporama) return;
  const k = parseInt(diaporama.getAttribute('initial-slide'), 10) || 0;
  if (k <= 0) return;
  const slides = [...galerie.querySelectorAll('slideshow-slides > slideshow-slide')];
  czPermuter(slides, k, (el, i) => {
    czAttr(el, 'style', /--slide-\d+/, `--slide-${i}`);
    czAttr(el, 'on:click', /\/open\/\d+/, `/open/${i}`);
    el.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    if (i === 0) el.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
  });
  const vignettes = [...galerie.querySelectorAll('.slideshow-controls__thumbnails > button')];
  czPermuter(vignettes, k, (el, i) => {
    czAttr(el, 'on:click', /\/select\/\d+/, `/select/${i}`);
    czAttr(el, 'aria-label', /\d+/, String(i + 1));
    if (i === 0) el.setAttribute('aria-selected', 'true');
    else el.removeAttribute('aria-selected');
  });
  const zoomVignettes = [...galerie.querySelectorAll('.dialog-thumbnails-list > button')];
  czPermuter(zoomVignettes, k, (el, i) => {
    czAttr(el, 'on:click', /\/handleThumbnailClick\/\d+/, `/handleThumbnailClick/${i}`);
    czAttr(el, 'on:pointerenter', /\/handleThumbnailPointerEnter\/\d+/, `/handleThumbnailPointerEnter/${i}`);
    if (i === 0) el.setAttribute('aria-selected', 'true');
    else el.removeAttribute('aria-selected');
  });
  const zoomMedias = [...galerie.querySelectorAll('.dialog-zoomed-gallery > li')];
  czPermuter(zoomMedias, k, (el, i) => czAttr(el, 'id', /-\d+$/, `-${i + 1}`));
  diaporama.setAttribute('initial-slide', '0');
}
document.addEventListener(
  StandardEvents.productSelect,
  (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        const html = detail && detail.html;
        if (!html || typeof html.querySelector !== 'function') return;
        czGalerieCouleurEnTete(html.querySelector('media-gallery'));
      })
      .catch(() => {});
  },
  true
);

/* 2. Compte à rebours de la vente flash (snippets/cz-badges-fiche.liquid). Date de fin JJ/MM/AAAA HH:MM. */
function czDateFr(txt) {
  const m = String(txt || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})/);
  return m ? new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5]) : null;
}
const czDeux = (n) => String(n).padStart(2, '0');
function czChronos() {
  const maintenant = Date.now();
  document.querySelectorAll('.cz-fiche-chrono[data-cz-fin]').forEach((el) => {
    const fin = czDateFr(el.dataset.czFin);
    const t = el.querySelector('.cz-fiche-chrono__texte');
    if (!fin || !t) return;
    const reste = fin.getTime() - maintenant;
    if (reste <= 0) {
      t.textContent = '⏱ ' + (el.dataset.czTermine || '');
      return;
    }
    const h = Math.floor(reste / 3600000);
    const m = Math.floor((reste % 3600000) / 60000);
    const s = Math.floor((reste % 60000) / 1000);
    t.textContent = '⏱ ' + czDeux(h) + ':' + czDeux(m) + ':' + czDeux(s);
  });
}
czChronos();
setInterval(czChronos, 1000);

/* 3. Estimation de livraison (blocks/cz-estimation-livraison.liquid). */
class CzEstimationLivraison extends HTMLElement {
  connectedCallback() {
    const d = this.dataset;
    const coupure = d.coupure !== undefined && d.coupure !== '' ? parseInt(d.coupure, 10) : null;
    const sansSam = d.sansSamedi === 'true';
    const sansDim = d.sansDimanche === 'true';
    const ferme = (j) => (j.getDay() === 6 && sansSam) || (j.getDay() === 0 && sansDim);
    const calcul = (jours) => {
      const depart = new Date();
      if (coupure !== null && depart.getHours() >= coupure) depart.setDate(depart.getDate() + 1);
      const j = new Date(depart);
      let n = 0;
      while (n < jours) {
        j.setDate(j.getDate() + 1);
        if (!ferme(j)) n++;
      }
      while (ferme(j)) j.setDate(j.getDate() + 1);
      return j;
    };
    const options = d.format === 'numbers' ? { day: 'numeric', month: 'numeric' } : { day: 'numeric', month: 'long' };
    if (d.jourSemaine === 'true') options.weekday = 'long';
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat(d.langue || document.documentElement.lang || 'fr', options);
    } catch (e) {
      fmt = new Intl.DateTimeFormat('fr', options);
    }
    const min = this.querySelector('[data-cz-date="min"]');
    const max = this.querySelector('[data-cz-date="max"]');
    if (min) min.textContent = fmt.format(calcul(parseInt(d.min, 10) || 0));
    if (max) max.textContent = fmt.format(calcul(parseInt(d.max, 10) || 0));
  }
}
if (!customElements.get('cz-estimation-livraison')) customElements.define('cz-estimation-livraison', CzEstimationLivraison);

/* 4. Ventes croisées (blocks/cz-ventes-croisees.liquid) : carrousel, choix de variante, ajout au panier. */
class CzVentesCroisees extends HTMLElement {
  connectedCallback() {
    this.piste = this.querySelector('[data-cz-vc-piste]');
    this.addEventListener('click', this.#clic);
    this.addEventListener('change', this.#choix);
    if (this.piste) this.piste.addEventListener('scroll', () => this.#tirets(), { passive: true });
  }
  get #index() {
    const p = this.piste;
    return p && p.clientWidth ? Math.round(p.scrollLeft / p.clientWidth) : 0;
  }
  #aller(i) {
    const p = this.piste;
    if (!p) return;
    const n = p.children.length;
    const cible = ((i % n) + n) % n; /* retour au début après la dernière, comme le LIVE (rewind) */
    p.scrollTo({ left: cible * p.clientWidth, behavior: 'smooth' });
  }
  #tirets() {
    const i = this.#index;
    this.querySelectorAll('[data-cz-vc-aller]').forEach((t, n) => t.classList.toggle('is-actif', n === i));
  }
  #clic = async (e) => {
    const fleche = e.target.closest('[data-cz-vc-fleche]');
    if (fleche) return this.#aller(this.#index + parseInt(fleche.dataset.czVcFleche, 10));
    const tiret = e.target.closest('[data-cz-vc-aller]');
    if (tiret) return this.#aller(parseInt(tiret.dataset.czVcAller, 10));
    const bouton = e.target.closest('[data-cz-vc-ajouter]');
    if (!bouton || !window.czPanier) return;
    const carte = bouton.closest('[data-cz-vc-carte]');
    const select = carte && carte.querySelector('[data-cz-vc-variante]');
    const id = select && select.value;
    if (!id) return;
    bouton.disabled = true;
    bouton.setAttribute('aria-busy', 'true');
    try {
      await window.czPanier.ajouter([{ id: Number(id), quantity: 1 }], 'cz-panier-ventes-croisees');
    } catch (err) {
      console.warn('[cz-ventes-croisees]', err);
    }
    bouton.disabled = false;
    bouton.removeAttribute('aria-busy');
  };
  #choix = (e) => {
    const select = e.target.closest('[data-cz-vc-variante]');
    if (!select) return;
    const opt = select.selectedOptions[0];
    const carte = select.closest('[data-cz-vc-carte]');
    if (!opt || !carte) return;
    const prix = carte.querySelector('[data-cz-vc-prix]');
    if (prix) {
      prix.textContent = opt.dataset.prix || '';
      if (opt.dataset.barre) {
        const s = document.createElement('s');
        s.textContent = opt.dataset.barre;
        prix.append(' ', s);
      }
    }
    const img = carte.querySelector('[data-cz-vc-image]');
    if (img && opt.dataset.image) {
      img.src = opt.dataset.image;
      img.removeAttribute('srcset');
    }
  };
}
if (!customElements.get('cz-ventes-croisees')) customElements.define('cz-ventes-croisees', CzVentesCroisees);

/* 5. Vidéos de la fiche : en mobile, une vidéo et demie visible et une flèche ronde à droite (LIVE). */
function czFlecheVideos() {
  document.querySelectorAll('[id$="__custom_section_videos_reels"] .group-block-content').forEach((rang) => {
    if (rang.dataset.czFleche || rang.children.length < 2) return;
    rang.dataset.czFleche = '1';
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'cz-videos-fleche';
    b.setAttribute('aria-label', '→');
    b.addEventListener('click', () => {
      const pas = rang.firstElementChild ? rang.firstElementChild.getBoundingClientRect().width + 15 : rang.clientWidth;
      const fin = rang.scrollLeft + rang.clientWidth >= rang.scrollWidth - 4;
      rang.scrollTo({ left: fin ? 0 : rang.scrollLeft + pas, behavior: 'smooth' });
    });
    rang.parentElement.style.position = 'relative';
    rang.after(b);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', czFlecheVideos);
else czFlecheVideos();

/* ------------------------------------------------------------------------------------------------
  Corrections de recette (21/10/2026) : galerie mobile du LIVE (cz-mobile-entetes, validé le 15/10).
  Moins de 750 px seulement : flèche « › » et points sous la photo, le point actif suit le défilement ;
  « - N couleurs » retiré du titre affiché (le h1 servi reste intact), même règle que le LIVE.
------------------------------------------------------------------------------------------------ */
function czGalerieMobile() {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
  const h1 = document.querySelector('.product-information .text-block h1');
  if (h1) h1.textContent = h1.textContent.replace(/\s*[-\u2013]\s*\d+\s*(couleurs?|colou?rs?|farben|colores|colori|kleuren|kolory)\s*$/i, '');
  const g = document.querySelector('.product-information media-gallery slideshow-component');
  if (!g || g.querySelector(':scope > .cz-gal-dots')) return;
  const scroller = g.querySelector('slideshow-slides');
  if (!scroller) return;
  const total = scroller.querySelectorAll(':scope > slideshow-slide').length;
  if (total < 2) return;
  const hint = document.createElement('div'); hint.className = 'cz-gal-hint'; hint.setAttribute('aria-hidden', 'true'); hint.textContent = '›';
  const dots = document.createElement('div'); dots.className = 'cz-gal-dots'; dots.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < total; i++) dots.appendChild(document.createElement('i'));
  g.appendChild(hint); g.appendChild(dots);
  const sync = () => {
    const w = scroller.clientWidth || 1;
    const idx = Math.max(0, Math.min(total - 1, Math.round(Math.abs(scroller.scrollLeft) / w)));
    for (let k = 0; k < dots.children.length; k++) dots.children[k].className = k === idx ? 'is-on' : '';
  };
  scroller.addEventListener('scroll', sync, { passive: true });
  sync();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', czGalerieMobile);
else czGalerieMobile();
document.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise?.then(() => setTimeout(czGalerieMobile, 50)).catch(() => {});
});
